import { NsuUpdateStatus } from "src/@types/store-deposit-maintenance";

export const DEPOSIT_MAINTENANCE_LABELS = {
  pageTitle: "Manutenção de Depósitos",
  pageDescription: "Corrija o NSU e a conta bancária dos depósitos da loja",
  storeLabel: "Loja",
  storePlaceholder: "Selecione a loja",
  periodLabel: "Período",
  periodPlaceholder: "Selecione o período",
  minAmountLabel: "Valor de",
  maxAmountLabel: "Valor até",
  amountPlaceholder: "0,00",
  nsuLabel: "NSU",
  nsuPlaceholder: "Ex.: 003440",
  linkFilterLabel: "Situação do vínculo",
  allOption: "Todos",
  searchButton: "Consultar",
  searching: "Consultando…",
  selectFiltersHint: "Selecione a loja e o período para consultar",
  emptyResult: "Nenhum depósito encontrado para os filtros selecionados",
  depositSingular: "depósito",
  depositPlural: "depósitos",
  previousPage: "Anterior",
  nextPage: "Próximo",
  openMenu: "Abrir Menu",
  editNsuAction: "Alterar NSU",
  bankDetailsAction: "Ver dados bancários",
  editAccountAction: "Alterar conta",
  cancelButton: "Cancelar",
  confirmButton: "Confirmar",
  closeButton: "Fechar",
  savingButton: "Salvando…",
  editNsuTitle: "Alterar NSU do depósito",
  editNsuDescription: "Informe o NSU que o banco atribuiu a este depósito",
  confirmNsuTitle: "Confirmação necessária",
  confirmNsuDescription: "Leia o aviso do sistema antes de confirmar",
  editAccountTitle: "Alterar conta do depósito",
  editAccountDescription:
    "Escolha a conta de destino. O banco vem junto com a conta escolhida.",
  bankDetailsTitle: "Dados bancários do depósito",
  bankDetailsDescription: "Conta para onde este depósito foi lançado",
  accountSelectLabel: "Nova conta",
  accountSelectPlaceholder: "Selecione a conta",
  currentAccountLabel: "Conta atual:",
  depositDateLabel: "Data",
  depositAmountLabel: "Valor",
  bankLabel: "Banco",
  agencyLabel: "Agência",
  accountLabel: "Conta",
  complementLabel: "Complemento",
} as const;

export interface FilterOption {
  readonly value: string;
  readonly label: string;
}

export enum LinkFilter {
  TODOS = 0,
  VINCULADOS = 1,
  NAO_VINCULADOS = 2,
}

export const LINK_FILTER_OPTIONS: readonly FilterOption[] = [
  { value: String(LinkFilter.VINCULADOS), label: "Vinculados" },
  { value: String(LinkFilter.NAO_VINCULADOS), label: "Não vinculados" },
];

export const NSU_UPDATE_STATUS: Record<
  "APPLIED" | "CONFIRMATION_REQUIRED",
  NsuUpdateStatus
> = {
  APPLIED: "APPLIED",
  CONFIRMATION_REQUIRED: "CONFIRMATION_REQUIRED",
};

export const NSU_MAX_LENGTH = 15;

export const NSU_SUFFIX_SEPARATOR = "_";
export const DEPOSIT_IDENTITY_SEPARATOR = "|";

export const EMPTY_AMOUNT = 0;
export const AMOUNT_MAX = 999999999.99;
export const AMOUNT_MAX_LENGTH = 12;

export const GLOBALLY_HANDLED_STATUS: ReadonlySet<number> = new Set([
  401, 403, 423,
]);

export const DISPLAY_DATE_FORMAT = "dd/MM/yyyy";
export const ISO_DATE_LENGTH = 10;
export const DISPLAY_TIME_LENGTH = 5;
export const LEGACY_EMPTY_DATE = "0001-01-01";
export const EMPTY_CELL = "-";

export const DEPOSIT_MAINTENANCE_MESSAGES = {
  MISSING_FILTERS: {
    description: "Selecione a loja e o período antes de consultar",
    variant: "destructive" as const,
  },
  NSU_UPDATED: {
    description: "NSU vinculado ao depósito",
  },
  NSU_ERROR: {
    description: "Não foi possível alterar o NSU",
    variant: "destructive" as const,
  },
  ACCOUNT_UPDATED: {
    description: "Conta do depósito alterada",
  },
  ACCOUNT_ERROR: {
    description: "Não foi possível alterar a conta",
    variant: "destructive" as const,
  },
};

export const NSU_CONFIRMATION_FALLBACK =
  "ATENÇÃO! ISSO É UM ALERTA.\n\nJá existe um NSU com esse número na base.\nConfirma essa operação?";

export const NSU_LENGTH_HINT = "Este banco usa NSU de {length} dígitos";
export const NSU_LENGTH_PLACEHOLDER = "{length}";

export const FIRST_PAGE = 1;
export const DEFAULT_PER_PAGE = 20;
